import apiService, { ApiService } from './ApiService';
import { apis } from '../utility/constants';
import { List, ListParams } from '../types/main';
import { ItemId, Organization } from '../types/items';
import { transformList } from './transformer';

class OrganizationService {
  private route = apis.organizations;

  constructor(private api: ApiService) {}

  list = (params: ListParams) => this.api
    .get<List<Organization>>(this.route.list, params)
    .then(transformList);

  get = (id: ItemId) => this.api.get<Organization>(`${this.route.list}/${id}`);

  template = () => this.api.get<Organization>(`${this.route.list}/new`);

  save = (id: ItemId, { ref, permissions, ...organization }: Organization) => {
    const filteredPayload = Object.fromEntries(
      Object.entries(organization)
        .map(([key, value]) => [key, (!value && value !== false) ? '' : value]),
    );

    return this.api.put<Organization>(
      `${this.route.list}/${id}`,
      filteredPayload,
    );
  };

  create = ({
    id, ref, permissions, ...organization
  }: Organization) => {
    const filteredPayload = Object.fromEntries(
      Object.entries(organization).map(([key, value]) => [key, value || '']),
    );

    return this.api.post<Organization>(this.route.list, filteredPayload);
  };

  delete = (id: ItemId) => this.api.delete(`${this.route.list}/${id}`);
}

export default new OrganizationService(apiService);
